import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { Moment } from 'moment';

const GetOrdersQuery = gql`
  query(
    $filterTotalFrom: Int,
    $filterTotalTo: Int,
    $filterPaid: [String!]
    $filterSearch: String,
    $filterStateId: [String!],
    $filterCreatedFrom: String,
    $filterCreatedTo: String,
    $filterDeliveryMethodId: [String!],
    $filterPaymentMethodId: [String!],
    $skip: Int, 
    $first: Int, 
    $eshopDomain: String!, 
    $customerId: String
  ) {
    orders(
      first: $first, 
      skip: $skip, 
      where: {
          customerId: $customerId, 
          eshop: { domain: $eshopDomain },
          search: $filterSearch,
          stateId: $filterStateId,
          deliveryMethodId: $filterDeliveryMethodId,
          paymentMethodId: $filterPaymentMethodId,
          createdFrom: $filterCreatedFrom,
          createdTo: $filterCreatedTo,
          totalFrom: $filterTotalFrom,
          totalTo: $filterTotalTo,
          paid: $filterPaid
      }
    ) {
      edges {
        node {
          id
          orderNumber
          grandTotal
          subTotal
          invoiceFirstName
          invoiceLastName
          email
          createdAt
          status
          paid
          currency {
            id
            value
            exchangeRate
          }
          orderedItems {
            id
          }
          customer {
            id
          }
          deliveryTotal
          deliveryMethod {
            id
            title
          }
          paymentMethod {
            id
            title
          }
          externalState {
            id
            title
            color
          }
        }
      }
      aggregate {
        count
      }
    }
  }
`;

const DeleteOrderMutation = gql`
  mutation delete($id: String!) {
    deleteOrder(id: $id) {
      id
    }
  }
`;

export interface OrderFilter {
  query?: string;
  page: number | undefined;
  createdAtFrom: string | null;
  createdAtTo: string | null;
  orderAmountFrom: string | null;
  orderAmountTo: string | null;
  orderState: string[] | null;
  orderPaid: string[] | null;
  deliveryMethod: string[] | null;
  paymentMethod: string[] | null;
}

interface IInputProps {
  children?: any;
  filter: OrderFilter;
  first?: number;
  skip?: number;
  search?: string;
  eshopId: string;
  domain: string;
  customerId?: string;
}

interface Response {
  data: any;
}

class OrdersQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { orders, deleteOrder }: any = this.props;
    return this.props.children({
      orders,
      deleteOrder
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(GetOrdersQuery, {
    name: 'orders',
    options: props => {
    return ({
      variables: {
        filterSearch: props.filter && props.filter.query || '',
        eshopDomain: props.domain ? props.domain : '',
        first: props.first,
        skip: props.skip,
        customerId: props.customerId,
        filterStateId: props && props.filter.orderState,
        filterCreatedFrom: props.filter && props.filter.createdAtFrom,
        filterCreatedTo: props.filter && props.filter.createdAtTo,
        filterDeliveryMethodId: props.filter && props.filter.deliveryMethod,
        filterPaymentMethodId: props.filter && props.filter.paymentMethod,
        filterPaid: props.filter && props.filter.orderPaid,
        filterTotalFrom: props.filter && props.filter.orderAmountFrom,
        filterTotalTo: props.filter && props.filter.orderAmountTo,
      },
      fetchPolicy: 'network-only'
    })
  }}),
  graphql<IInputProps, Response>(DeleteOrderMutation, {
    name: 'deleteOrder'
  })
)(OrdersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Orders/MinimalOrders.tsx